import CheckboxFilter from "../Common/CheckboxFilter";
import { colorData } from "../../../../data/category/inputData";

const Color = () => {
  return (
    <CheckboxFilter
      filterName={"color"}
      filterData={colorData}
      title={"color"}
    />
  );
};
export default Color;
